{
  "added_success_link": "View item",
  "added_success_secondary": "Check your email for an invitation",
  "added_success_title": "✨ Item added to your calendar!",
  "cta_text": "Add",
  "cta_tooltip": "We'll email you a calendar invite to this event"
}
